module.exports = __webpack_public_path__ + "img/hg.500072e7.png";